import { z } from 'zod';
import { copySchema } from './copy.ts';
import { instant } from './primitives.ts';

export const newsStorySchema = z.object({
  id: z.number(),
  kind: z.enum(['OUTCOME', 'FILING', 'REPORT', 'MOVE']),
  standing: z.enum(['OFFICIAL', 'CONFIRMED', 'REPORTED', 'WITHDRAWN']),
  title: z.string(),
  /** The title without its icon. */
  headline: z.string(),
  copy: copySchema,
  openedAt: instant,
  changedAt: instant,
  yours: z.boolean(),
  /** What of the reader's it moves, as a note names it: `Natural gas`, `Indian shares`. */
  touches: z.array(z.string()),
  sources: z.array(z.object({ by: z.string(), at: instant, href: z.string().nullable() })),
});

export type NewsStory = z.infer<typeof newsStorySchema>;

export const newsSchema = z.object({ stories: z.array(newsStorySchema) });

export type NewsRead = z.infer<typeof newsSchema>;
